import { OnlineSales } from 'gw-edge-client';
import { selector } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import axios from 'axios';
import { GATEWAY_TIMEOUT_STATUS_CODE } from '../types/types';

export const generateQuoteDocumentSelector = selector({
    key: 'generateQuoteDocumentSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        let document;
        try {
            document = await OnlineSales.generateQuoteDocument(jobNumber, sessionId);
        } catch (err) {
            if (axios.isAxiosError(err) && err.response?.status === GATEWAY_TIMEOUT_STATUS_CODE) {
                return undefined;
            } else {
                throw Error((err as Error).message);
            }
        }
        if (!document?.base64PDF) {
            throw Error('Kunne ikke generere og hente Tilbud');
        }
        return document;
    }
});
